import FontSelect from './FontSelect';

export default FontSelect;
